import React from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Pagination } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";

const openLink = url => {
  if (url) window.open(url, "_blank", "noopener,noreferrer");
};

function PromoCard({ ad, onActivate }) {
  const handleActivate = () => {
    if (onActivate) onActivate();
    openLink(ad.advertisementImageLink);
  };

  return (
    <div
      className="rp-promo-item"
      role="button"
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={e => e.key === "Enter" && handleActivate()}
    >
      {ad.advertisementImage ? (
        <img
          src={ad.advertisementImage}
          alt={ad.promotionalProductName || "Offer"}
        />
      ) : (
        <div className="rp-promo-placeholder">
          {ad.promotionalProductName || "Special offer"}
        </div>
      )}
      {ad.promotionalProductName && (
        <div className="rp-promo-name">{ad.promotionalProductName}</div>
      )}
    </div>
  );
}

export default function ReceiptPromoSection({ ads = [] }) {
  const safeAds = ads || [];
  if (safeAds.length === 0) return null;

  return (
    <section className="rp-card rp-promo-section">
      <h2 className="rp-section-title">Special offers</h2>

      {safeAds.length === 1 ? (
        <div className="rp-promo-single">
          <PromoCard ad={safeAds[0]} />
        </div>
      ) : (
        <div className="rp-promo-slider-wrap">
          <Swiper
            spaceBetween={14}
            slidesPerView={1}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="rp-promo-swiper"
          >
            {safeAds.map((ad, index) => (
              <SwiperSlide key={ad.advertisementId || `promo-${index}`}>
                <PromoCard ad={ad} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </section>
  );
}
